const id_trans_itemin = {
    "": "barang masuk",
    add: "buat barang masuk",

    label: {
        sn_upload_text: "Unduh contoh file EXCEL upload Serial Number",
    },

    error: {
        create: "Gagal membuat barang masuk",
        edit: "Gagal mengubah barang masuk",
    },

    success: {
        create: "Berhasil membuat barang masuk",
        edit: "Berhasil mengubah barang masuk",
    },
}

export default id_trans_itemin;